import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { MagazinesResource, UsersResources } from '@/resources'
import { getTranslation } from '@/store/getters'
import { toggleToaster } from '@/store/actions'

import styles from './styles.scss'

class MagazineEdit extends Component {
  state = {
    email: ''
  }

  handleTransferMagazine = async () => {
    const { email } = this.state
    const { id, id_domain, title, description, properties } = this.props.magazine

    const { translation, toggleToaster, handleClose } = this.props

    try {
      const { data } = await UsersResources.getUserId({ email })

      await MagazinesResource.clone(id, {
        id_usuario: data.id_usuario,
        id_domain,
        title,
        description,
        properties
      })

      handleClose()

      toggleToaster({
        isVisible: true,
        message: translation('magazine-transfer-success'),
        position: 'top-right',
        type: 'success'
      })

    } catch (error) {
      console.error(error)

      toggleToaster({
        isVisible: true,
        message: translation('login-wrong-email-format'),
        position: 'top-right',
        type: 'error'
      })
    }
  }

  render() {
    const { email } = this.state
    const { show, translation, handleClose } = this.props

    return (
      <section className={'ba-flex ba-jc-center ba-ai-center ' + (show ? styles['ba-modal'] : styles['ba-none'])}>
        <div className={'ba-card ' + styles['ba-modal-card']}>
          <div className="ba-top ba-flex ba-jc-sb">
            <span className="ba-montserrat-700">
              {translation('transfer-magazine')}
            </span>

            <button className='ba-btn ba-btn-close ba-sm ba-rounded'
              onClick={handleClose}>
              <builderall-icon code='64f7' />
            </button>
          </div>

          <div className="ba-top">
            <span className={"ba-title " + styles['ba-subtitle']}>
              {translation('transfer-alert')}
            </span>
          </div>

          <div className="ba-content ba-w-100">

            <div className='ba-box-input ba-mg-t-1'>
              <div className='ba-info'>
                <div className='ba-info-left'>
                  <label className='ba-label' for='email'>
                    E-mail
                  </label>
                </div>
              </div>
              <input type='text' id='email' className='ba-input' maxLength="50"
                placeholder={translation('transfer-email')}
                value={email}
                onChange={({ target }) => this.setState({ email: target.value })} />
            </div>

            <div className='ba-flex ba-jc-fe ba-mg-t-3'>
              <button className='ba-btn ba-md ba-blue'
                disabled={!this.state.email}
                onClick={this.handleTransferMagazine}>
                <builderall-icon code='2780' />
                {translation('transfer')}
              </button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default withRouter(connect(
  mapStateToProps, {
  toggleToaster
}
)(MagazineEdit))



// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineTransfer/index.js